module.exports = __webpack_public_path__ + "img/tn-timeline-main-10.3818f2ea.jpg";